import { moneyOrZero, formatMoney } from "@faire/web--source/common/money";
import { IBrandReferralPromotion } from "@faire/web-api--source/indigofair/brand/referrals/IBrandReferralPromotion";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";

import { getReferralPromotions } from "@faire/retailer/serialized-data/getReferralPromotions";
import { getSettingR2BAwardConfiguration } from "@faire/retailer/settings/getSettingR2BAwardConfiguration";

const formatAward = (award: IFaireMoney) =>
  formatMoney({
    money: award,
    omitCentsIfZero: true,
    disableAutoConvertCurrency: true,
  });

export const useR2BAwardStore = () => {
  const incentiveActivationAmount = moneyOrZero(
    getSettingR2BAwardConfiguration().r2b_activation_amount
  );

  const incentiveActivationAmountFormatted = formatAward(
    incentiveActivationAmount
  );

  const incentivePerOrderAmount = moneyOrZero(
    getSettingR2BAwardConfiguration().r2b_per_order_amount
  );

  const incentivePerOrderAmountFormatted = formatAward(incentivePerOrderAmount);

  const activePromotions = new Set(
    getReferralPromotions()
      ?.map((brandReferralPromotion) => brandReferralPromotion.promotion_type)
      .filter(
        (
          promotionType
        ): promotionType is IBrandReferralPromotion.PromotionType =>
          promotionType !== undefined
      )
  );

  const r2bAdvertisedRetailerAward = moneyOrZero(
    getSettingR2BAwardConfiguration().r2b_max_credits
  );

  const r2bAdvertisedRetailerAwardFormatted = formatAward(
    r2bAdvertisedRetailerAward
  );

  const hasActivationAmount = Boolean(
    incentiveActivationAmount.amount_cents &&
      incentiveActivationAmount.amount_cents > 0
  );

  return {
    incentiveActivationAmount,
    incentiveActivationAmountFormatted,
    incentivePerOrderAmountFormatted,
    activePromotions,
    r2bAdvertisedRetailerAward,
    r2bAdvertisedRetailerAwardFormatted,
    hasActivationAmount,
  };
};
